module.exports = __webpack_public_path__ + "img/DesktopMacOutlined.83dfbf6c.svg";